/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Product Image Selector
// let mainProductImage = document.getElementById('main-product-image');
// let productThumbnails = document.querySelectorAll('.thumbnail-product-image');

// if (productThumbnails.length > 0 && mainProductImage !== null) {
// 	for (let i = 0; i < productThumbnails.length; i++) {
//       // Set first image as active by default
//       productThumbnails[0].classList.add('active');
      
//       // Set up click function to change images and active class
//       productThumbnails[i].addEventListener('click', function () {
//         let productThumbnailsActive = document.querySelectorAll('.thumbnail-product-image.active');
//         let imgSrc = this.getAttribute('data-media-url');

//         mainProductImage.src = imgSrc;
        
//         // Handle active class
//         for (let j = 0; j < productThumbnailsActive.length; j++) {
//           productThumbnailsActive[j].classList.remove('active');
//         }
        
//         this.classList.add('active');
//       });
//     }
// }

let productThumbnailBtns = document.querySelectorAll('.thumbnail-product-image');
let firstProductThumbnailBtn = document.querySelector('.thumbnail-product-image');
let allProductImageContainers = document.querySelectorAll('.product__media-container');
if (firstProductThumbnailBtn !== null) {
    firstProductThumbnailBtn.classList.add('active');
}

for (let i = 0; i < productThumbnailBtns.length; i += 1) {
    productThumbnailBtns[i].addEventListener('click', function () {
        let activeThumbnailBtn = document.querySelector('.thumbnail-product-image.active');
        activeThumbnailBtn.classList.remove('active');
        this.classList.add('active');
        for (const imageContainer of allProductImageContainers) {
            let changeSrc = this.getAttribute('data-media-url');
            let productImage = imageContainer.querySelector('img');
            if (productImage.hasAttribute('data-src') === false) {
                productImage.setAttribute('data-src', productImage.src);
            }

            if (this.getAttribute('data-media-id') === firstProductThumbnailBtn.getAttribute('data-media-id')) {
                changeSrc = productImage.getAttribute('data-src');
            }

            productImage.src = changeSrc;
        }
    });
}

// Initialize Owl Carousel
$(document).ready(function(){
  $('.owl-carousel').owlCarousel({
    items: 1,
    loop: true,
    autoplay: true,
    dots: false,
  });
});